import Cookies from "js-cookie";
import store from "../store/index.js";
import api from "../commonJs/http.js";

function Authorization(to, next) {
  let needNext = true;
  //判断路由中是否存在SeesionKey、Account、Token、PassWord、Ticket参数，若存在则是第一次登录传递的参数，需要保存后处理掉该参数
  if (to.query["SessionKey"]) {
    let cookiesValue ="username=" +to.query["Account"] +"&SessionKey=" +to.query["SessionKey"] +"&&PassWord=" +to.query["PassWord"];
    if (Cookies.get(process.env.VUE_APP_COOKIES)) {
      Cookies.remove(process.env.VUE_APP_COOKIES);
    }
    Cookies.set(process.env.VUE_APP_COOKIES, cookiesValue, {expires: 3,});
    Cookies.set("username", to.query["Account"], { expires: 3, });
    Cookies.set("password", to.query["PassWord"], { expires: 3, });
    store.commit("saveToken", to.query["Ticket"]);
    //去除sso传来的参数并重新定向
    let queryParam = {};
    for (var p in to.query) {
      if (
        p != "SessionKey" &&
        p != "Account" &&
        p != "PassWord" &&
        p != "Token" &&
        p != "Ticket"
      ) {
        queryParam[p] = to.query[p];
      }
    }
    next({
      path: to.path,
      query: queryParam,
    });
    needNext = false;
  }
  if (!store.state.token) {
    //如果没有，优先去缓存取
    store.commit("saveToken", window.localStorage.Token);
  }
  if (!(store.state.token && store.state.token != "undefined")) {
    //如果未发现token,重置stroe，token状态，跳转到sso登录
    store.commit("saveToken", "");
    RedirectLogin(); //跳转到sso登录页面
    needNext = false;
  }
  //当访问的路径在菜单数据中不存在，这里暂时不做判断了，即只要路由中配置了path的，手动输入均可访问
  return needNext;
}

function RedirectLogin() {
  // let to = window.location.href;
  let to =window.location.protocol +"//" +window.location.host +(window.location.pathname == "/" ? "/" : window.location.pathname) +"#/Admin/Index"; //这里重定向要加后面/#/
  let loginUrl =process.env.VUE_APP_LOGIN_URL +"login?RedirectUrl=" +encodeURIComponent(to) + "&sysid=" +process.env.VUE_APP_SYSID;
  window.location.href = loginUrl;
}

export default {
  Authorization: function (to, next) {
    return Authorization(to, next);
  },
};
